// extracted by mini-css-extract-plugin
export var close = "modal-module--close--fb64e";
export var content = "modal-module--content--8836a";
export var root = "modal-module--root--00e0d";